/**
 * BeX MCP service clients — OAuth client_credentials for MACHINE callers.
 *
 * Talks to bex-server's /cm/mcp-service-clients. A service client is what an
 * MCP connection (a digital employee calling the BeX Platform MCP) needs: the
 * BeX MCP only accepts short-lived OAuth tokens, so a pasted bearer token dies
 * within the hour. With a client id + secret, Project-O fetches fresh tokens
 * itself (auth type `oauth2`).
 *
 * The secret is returned ONCE, by create(); the server keeps only its hash.
 */
import {
    bexHttpClient
} from '../../clients';

export interface MCPServiceClient {
    client_id: string;
    name: string;
    organizationId: string;
    subOrganizationId: string;
    scopes: string[];
    created_by: string;
    created: string;
}

export interface CreatedMCPServiceClient extends MCPServiceClient {
    client_secret: string;
    token_url: string;
    mcp_url: string;
}

class MCPServiceClientService {
    private baseURL = '/mcp-service-clients'; // bexHttpClient prepends /cm

    async create(data: {
        organizationId: string;
        subOrganizationId: string;
        name?: string;
        scopes?: string[];
    }): Promise<CreatedMCPServiceClient> {
        const response = await bexHttpClient.post<CreatedMCPServiceClient>(this.baseURL, data);
        return response.data;
    }

    async list(organizationId: string, subOrganizationId?: string): Promise<MCPServiceClient[]> {
        const params = new URLSearchParams({
            organizationId
        });
        if (subOrganizationId) params.set('subOrganizationId', subOrganizationId);
        const response = await bexHttpClient.get<MCPServiceClient[]>(`${this.baseURL}?${params}`);
        return response.data;
    }

    async revoke(organizationId: string, clientId: string): Promise<void> {
        await bexHttpClient.delete(
            `${this.baseURL}/${encodeURIComponent(clientId)}?organizationId=${encodeURIComponent(organizationId)}`,
        );
    }
}

export const mcpServiceClientService = new MCPServiceClientService();
export default mcpServiceClientService;
